// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';
import { useTheme } from "@mui/material";

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useMockedUser();
  const theme = useTheme();
  const navData: any = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        backgroundColor: theme.palette.mode === "dark" ? '#1c252e' : '#faf8f8',
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI + 1 },
      }}
    >

      <NavToggleButton
        sx={{
          top: 8,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          overflow: "visible"
        }}
      >
        <Logo sx={{ mx: 'auto' }} />

        <Box
          sx={{
            position: 'absolute',
            top: 65, // arrêt 10px avant le coin
            right: 0,
            bottom: 0,
            width: '10px',
            borderRight: (t) => `dashed 1.5px ${t.palette.divider}`,
            pointerEvents: 'none',
          }}
        />

        <Box sx={{ width: 20, height: 20, position: 'absolute', top: 40, right: -10, background: theme.palette.mode === "dark" ? "#1c252e!important" : "#faf8f8!important" }} />

        {/* Nav sans Administration */}
        <NavSectionMini
          sx={{ position: "relative", top: 26 }}
          data={navData.filter((item: any) => item.subheader !== 'Administration')}
          config={{
            currentRole: user?.role || 'admin',
          }}
        />
        <Box sx={{ flexGrow: 1 }} />

        {/* Nav Administration tout en bas */}
        <NavSectionMini
          sx={{ pb: 2 }}
          data={navData.filter((item: any) => item.subheader === 'Administration')}
          config={{
            currentRole: user?.role || 'admin',
          }}
        />


      </Stack>
    </Box>
  );
}
